import { render } from "./ui-months.vue?vue&type=template&id=073f4760&ts=true"
import script from "./ui-months.vue?vue&type=script&lang=ts"
export * from "./ui-months.vue?vue&type=script&lang=ts"

import "./ui-months.vue?vue&type=style&index=0&id=073f4760&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__